import deleteFetcher from 'api/utils/deleteFetcher';
import { useCallback } from 'react';
import type { LegacyDeviceWebhook } from 'types/legacyDashboard';

interface DeleteWebhookProps {
  deviceId?: DeviceId;
}

interface DeleteWebhookReturn {
  data: LegacyDeviceWebhook;
  success: boolean;
}

const useDeleteWebhook = ({ deviceId }: DeleteWebhookProps) => {
  const url = `${process.env.VITE_API_ROOT}/devices/${deviceId}/webhook`;

  const callback = useCallback(async () => {
    const result: DeleteWebhookReturn | undefined = await deleteFetcher({
      url,
      body: {},
    });

    return result;
  }, [url]);

  return callback;
};

export default useDeleteWebhook;
